export const addContribution = {
  component: '',
  event: '',
  party: '',
  type: '',
  reference: '',
  completed:'',
  partly_estimated:'',
  estimated_occurence:'',
  description:''
}
export const ContributionHd = [
  { label: 'Component', sortOption: false },
  { label: 'Party', sortOption: false },
  { label: 'Type', sortOption: false },
  { label: 'Completed', sortOption: false },
  { label: 'Description', sortOption: false },
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action(s)', sortOption: false },
];
export const errorCode = {
  component:{
    0:'',
    1: 'Please enter Component '
  },
  contributionObj: {
    required: true
  }
}
